const switchActionHandler = (actiontype, that) => {
  switch(true){
    case actiontype === "mapchange":
      if (that.get(0).checked) {
        that.closest('.switch-wrapper').addClass('is_checked map').removeClass('list')
      }
      else {
        that.closest('.switch-wrapper').removeClass('is_checked map').addClass('list')
      }
      break;
    case actiontype === "eventchange":
      const newVal = that.get(0).checked ? "<" : ">=" ;
      jQuery('.views-exposed-form select[name="future"] option[value="' + newVal + '"]').prop('selected', true);
      jQuery('.views-exposed-form input[id^="edit-submit-events"]').click();
      break;
    default:
      console.log("no handler")
      break;
  }
}
